// extracted by mini-css-extract-plugin
module.exports = {"pagimovelLogoContainer":"HeaderBanner_pagimovelLogoContainer__2hCh2"};